export default "__VITE_ASSET__DFTIExJL__"